module.exports = __webpack_public_path__ + "static/img/miles_profile_700x740.f530e03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/miles_profile_700x740.jpg
// module id = FitJ
// module chunks = 0